import React from "react";
import { Link } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";
import {
  NOVEMBER_CAREERS_SURVEY_PATH,
  UUN_PRIVACY_CONTACT_EMAIL,
} from "./housingDevelopment/config";

const contactHref = `mailto:${UUN_PRIVACY_CONTACT_EMAIL}?subject=${encodeURIComponent(
  "Housing & Development survey information request"
)}`;

export default function PrivacyNotice() {
  return (
    <main className="mx-auto w-full max-w-4xl">
      <header className="overflow-hidden rounded-[1.75rem] border border-white/15 bg-gradient-to-br from-[#084c5b] to-[#071d2a] p-6 shadow-2xl sm:p-10">
        <ShieldCheck className="h-11 w-11 text-[#7ff3e1]" aria-hidden="true" />
        <p className="mt-5 text-sm font-black uppercase tracking-[0.16em] text-[#7ff3e1]">
          Your information
        </p>
        <h1 className="mt-2 text-4xl font-black tracking-tight text-white sm:text-6xl">
          Privacy notice
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-8 text-white/80">
          This notice explains how Urban Unity Network handles information
          submitted through the Riverside x Kier Careers Fair survey.
        </p>
      </header>

      <div className="mt-6 grid gap-5">
        <section className="rounded-3xl border border-white/15 bg-white/5 p-6 sm:p-8">
          <h2 className="text-2xl font-black text-white">What the survey collects</h2>
          <p className="mt-3 leading-7 text-white/75">
            The survey asks for your name and email address. A phone number and
            home address or postcode are optional. It also asks about local
            housing, attendance and the careers support you may be interested in.
          </p>
        </section>

        <section className="rounded-3xl border border-white/15 bg-white/5 p-6 sm:p-8">
          <h2 className="text-2xl font-black text-white">How the information is used</h2>
          <p className="mt-3 leading-7 text-white/75">
            Urban Unity Network uses the answers to manage survey responses,
            understand interest in the Careers Fair and plan relevant event
            support. Survey answers are not published. Stored responses are
            available only through authorised Urban Unity Network admin access.
          </p>
        </section>

        <section className="rounded-3xl border border-[#20c9b4]/40 bg-[#20c9b4]/10 p-6 sm:p-8">
          <h2 className="text-2xl font-black text-white">How long responses are kept</h2>
          <p className="mt-3 leading-7 text-white/80">
            The survey closes at the end of 30 November 2026. Responses that can
            identify a person will be kept until 30 November 2027. After that,
            they will be deleted or anonymised.
          </p>
        </section>

        <section className="rounded-3xl border border-white/15 bg-white/5 p-6 sm:p-8">
          <h2 className="text-2xl font-black text-white">Questions about your response</h2>
          <p className="mt-3 leading-7 text-white/75">
            To ask about the information you submitted, or to request a
            correction, deletion or anonymisation, contact Urban Unity Network at{" "}
            <a className="font-bold text-[#98f5e7] underline underline-offset-4" href={contactHref}>
              {UUN_PRIVACY_CONTACT_EMAIL}
            </a>
            . Include enough information for UUN to identify the response you
            are asking about, but do not email extra sensitive information.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              className="inline-flex min-h-12 items-center justify-center rounded-xl bg-[#20c9b4] px-5 py-3 font-black text-[#032822] hover:bg-[#5fe2d0]"
              to={NOVEMBER_CAREERS_SURVEY_PATH}
            >
              Return to the survey
            </Link>
            <a
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-white/25 bg-white/5 px-5 py-3 font-black text-white hover:bg-white/10"
              href={contactHref}
            >
              <Mail className="h-5 w-5" aria-hidden="true" /> Email UUN
            </a>
          </div>
        </section>
      </div>

      <p className="mt-6 text-sm text-white/55">Last updated: 21 October 2026.</p>
    </main>
  );
}
